import styled from 'styled-components'
import { color } from 'utils'

export const BalanceContainer = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  color: ${color('grey200')};
`

export const LearnMoreLink = styled.a`
  color: ${color('blue600')};
  text-decoration: none;

  :hover {
    color: ${color('blue500')};
  }
`

export const MaximumAmount = styled.span`
  cursor: pointer;
  color: ${color('blue600')};

  :hover {
    color: ${color('blue500')};
  }
`
